// extracted by mini-css-extract-plugin
module.exports = {"card":"Index_card__3PrNL","gameTitle":"Index_gameTitle__24iFo","gameEmoji":"Index_gameEmoji__wpzus","butt":"Index_butt__1-Dzf"};